import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { languages } from '@/common/constants'
import { getCurrentAvailableLanguage } from '@/configuration/helpers/helpers'
import {
  buildEmptyTranslations,
  getMissingLanguages,
  isCustomTextEnabled,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'
import useStoreLanguages from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/hooks/useStoreLanguages/useStoreLanguages'

const useBlockSettingTranslatedText = ({ field, value, onChange }) => {
  const { t, i18n } = useTranslation()
  const storeLanguages = useStoreLanguages()

  const [selectedLanguage, setSelectedLanguage] = useState(getCurrentAvailableLanguage(storeLanguages, i18n.language))

  const customTextEnabled = isCustomTextEnabled(value)
  const missingLanguages = getMissingLanguages(field, value, storeLanguages)

  const languageTabs = storeLanguages.map(language => ({
    value: language,
    label: languages(t).find(option => option.value === language)?.label,
    error: missingLanguages.includes(language),
  }))

  const handleChangeText = event => onChange(field.key, { ...value, [selectedLanguage]: event.target.value })

  const handleToggleCustomText = event => {
    onChange(field.key, event.target.checked ? buildEmptyTranslations(storeLanguages) : {})
  }

  return {
    languageTabs,
    selectedLanguage,
    selectLanguage: setSelectedLanguage,
    customTextEnabled,
    showTextInput: !field.showToggle || customTextEnabled,
    hasSelectedLanguageError: missingLanguages.includes(selectedLanguage),
    handleChangeText,
    handleToggleCustomText,
  }
}

export default useBlockSettingTranslatedText
